export const TASK_STATUS = {
  IN_PROGRESS: "IN_PROGRESS",
  CANCELED: "CANCELED",
  FAILED: "FAILED",
  FAILED_WITH_TERMINAL_ERROR: "FAILED_WITH_TERMINAL_ERROR",
  COMPLETED: "COMPLETED",
  COMPLETED_WITH_ERRORS: "COMPLETED_WITH_ERRORS",
  SCHEDULED: "SCHEDULED",
  TIMED_OUT: "TIMED_OUT",
  SKIPPED: "SKIPPED",
  PENDING: "PENDING",
};
